// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components-list----ListCard-module---root---1aIfy","titleRow":"src-components-list----ListCard-module---titleRow---ZZ_2L","icon":"src-components-list----ListCard-module---icon---HCK6G","title":"src-components-list----ListCard-module---title---3xhRP","description":"src-components-list----ListCard-module---description---1pvmt","count":"src-components-list----ListCard-module---count---3Ndm1"};


//////////////////
// WEBPACK FOOTER
// ./src/components/list/ListCard.module.css
// module id = 641
// module chunks = 84419135593297